import { EditorContent, useEditor } from '@tiptap/react';
import classNames from 'classnames';
import React, { forwardRef, useImperativeHandle } from 'react';
import { defaultEditorExtensions } from "./DefaultEditorExtensions.js";
import { toHTML } from "./helper/toHTML.js";
import { toMarkdown } from "./helper/toMarkdown.js";
import { useStickedToolbar } from "./hooks/useStickedToolbar.js";
import { useHeaderHeight } from "../../helper/hooks/useHeaderHeight.js";
import { EditorToolbar } from "../editorToolbar/EditorToolbar.js";
import { getMarkdownConfig } from "../editorToolbar/defaults/getMarkdownConfig.js";
import styles from "./Editor.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Editor = /*#__PURE__*/forwardRef(({
  extensions = defaultEditorExtensions,
  fixedHeight,
  initialContent,
  onChange,
  toolbarChildren,
  type
}, ref) => {
  const {
    toolbar,
    sticked
  } = useStickedToolbar();
  const toolbarOffset = useHeaderHeight();
  const editor = useEditor({
    content: initialContent ? toHTML(initialContent) : '',
    onUpdate: ({
      editor,
      transaction
    }) => {
      const html = editor.getHTML();
      if (type === 'HTML') {
        onChange(html);
      } else if (type === 'MARKDOWN') {
        onChange(toMarkdown(html));
      }
    },
    extensions,
    editorProps: {
      attributes: {
        class: styles.editor
      }
    }
  });
  useImperativeHandle(ref, () => {
    return {
      setInitialValue: value => {
        const html = toHTML(value);
        editor?.commands?.setContent(html);
      },
      editor
    };
  }, [editor]);
  return /*#__PURE__*/_jsxs("div", {
    children: [editor && /*#__PURE__*/_jsx(EditorToolbar, {
      className: classNames(styles.toolbar, {
        [styles.sticked]: sticked
      }),
      style: {
        '--toolbar-offset': `${toolbarOffset}px`
      },
      sections: getMarkdownConfig(editor),
      ref: toolbar,
      children: toolbarChildren
    }), fixedHeight ? /*#__PURE__*/_jsx("div", {
      className: styles.scrollContainer,
      onClick: () => editor?.commands.focus(),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.scrollInner,
        style: {
          height: `${fixedHeight}px`
        },
        children: /*#__PURE__*/_jsx(EditorContent, {
          editor: editor
        })
      })
    }) : /*#__PURE__*/_jsx(EditorContent, {
      editor: editor
    })]
  });
});